// Clinical Grammar & Morphology Inflection Engine (Proloquo2Go Parity)

export interface GrammarInflection {
  label: string;
  type: 'verb_tense' | 'noun_plural' | 'possessive';
}

export const getVerbInflections = (verb: string): GrammarInflection[] => {
  const clean = verb.trim().toUpperCase();
  
  // Custom irregular verbs common in clinical AAC
  const irregularMap: Record<string, { progressive: string; past: string; infinitive: string }> = {
    'EAT': { progressive: 'EATING', past: 'ATE', infinitive: 'TO EAT' },
    'GO': { progressive: 'GOING', past: 'WENT', infinitive: 'TO GO' },
    'HAVE': { progressive: 'HAVING', past: 'HAD', infinitive: 'TO HAVE' },
    'WANT': { progressive: 'WANTING', past: 'WANTED', infinitive: 'WANTS' },
    'PLAY': { progressive: 'PLAYING', past: 'PLAYED', infinitive: 'TO PLAY' },
    'LIKE': { progressive: 'LIKING', past: 'LIKED', infinitive: 'LIKES' },
    'HELP': { progressive: 'HELPING', past: 'HELPED', infinitive: 'TO HELP' },
    'SLEEP': { progressive: 'SLEEPING', past: 'SLEPT', infinitive: 'TO SLEEP' },
    'DRINK': { progressive: 'DRINKING', past: 'DRANK', infinitive: 'TO DRINK' },
    'STOP': { progressive: 'STOPPING', past: 'STOPPED', infinitive: 'TO STOP' },
  };

  if (irregularMap[clean]) {
    const item = irregularMap[clean];
    return [
      { label: clean, type: 'verb_tense' },
      { label: item.progressive, type: 'verb_tense' },
      { label: item.past, type: 'verb_tense' },
      { label: item.infinitive, type: 'verb_tense' },
    ];
  }

  // Regular conjugation
  const progressive = clean.endsWith('E') ? clean.slice(0, -1) + 'ING' : clean + 'ING';
  const past = clean.endsWith('E') ? clean + 'D' : clean + 'ED';

  return [
    { label: clean, type: 'verb_tense' },
    { label: progressive, type: 'verb_tense' },
    { label: past, type: 'verb_tense' },
    { label: `TO ${clean}`, type: 'verb_tense' },
  ];
};

export const getNounInflections = (noun: string): GrammarInflection[] => {
  const clean = noun.trim().toUpperCase();

  const irregularPluralMap: Record<string, string> = {
    'WATER': 'SOME WATER',
    'FOOD': 'MORE FOOD',
    'FOOT': 'FEET',
    'PERSON': 'PEOPLE',
    'CHILD': 'CHILDREN',
  };

  const plural = irregularPluralMap[clean] 
    || (clean.endsWith('S') || clean.endsWith('X') || clean.endsWith('CH') ? clean + 'ES' : clean + 'S');

  return [
    { label: clean, type: 'noun_plural' },
    { label: plural, type: 'noun_plural' },
    { label: `MY ${clean}`, type: 'possessive' },
  ];
};
